import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import moment from 'moment';
import { getCustodyFileDataUrl, getHandover } from './api';

// Loss and damage form (RUA "constat") as PDF, built from the stored, signed handover record.

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const fmt = (t) => moment(t).format('DD.MM.YYYY HH:mm:ss');
const TRANSPORT = { GEMI: 'Gemi', TIR: 'Tır', TREN: 'Tren', SURUS: 'Sürüş', DIGER: 'Diğer' };

const buildHtml = (h, files) => {
    const v = h.vehicle || {};
    const damages = h.lines.filter((l) => l.line_type === 'HASAR');
    const notes = h.lines.filter((l) => l.line_type !== 'HASAR');
    const photos = damages.flatMap((l) => l.photos.map((p) => ({ ...p, line: l })));
    const cell = 'border:1px solid #9aa3b5;padding:4px 6px;vertical-align:top;';
    const th = cell + 'background:#e9edf5;font-weight:600;text-align:left;';
    return `
<div style="width:794px;padding:28px 32px;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#111;background:#fff;box-sizing:border-box">
  <div style="display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #15287c;padding-bottom:6px">
    <div><div style="font-size:18px;font-weight:700;color:#15287c">HASAR VE DEVİR-TESLİM TUTANAĞI</div>
      <div style="font-size:10px;color:#444">Loss and damage report — RUA Checking Procedure DQ_CLIE10_0069 v3.5</div></div>
    <div style="text-align:right"><div style="font-size:15px;font-weight:700">${esc(h.handover_no)}</div>
      <div>${fmt(h.handover_at)}</div></div>
  </div>
  <table style="width:100%;border-collapse:collapse;margin-top:10px">
    <tr><td style="${th}width:18%">VIN</td><td style="${cell}width:32%;font-weight:700;letter-spacing:1px">${esc(h.chassis_no)}</td>
        <td style="${th}width:18%">Devir-teslim noktası</td><td style="${cell}">${esc(h.point_name)}</td></tr>
    <tr><td style="${th}">Marka / model</td><td style="${cell}">${esc(v.brand)} ${esc(v.model)}</td>
        <td style="${th}">Lokasyon</td><td style="${cell}">${esc(h.location_name)}</td></tr>
    <tr><td style="${th}">Renk (kod)</td><td style="${cell}">${esc(v.colour)} (${esc(v.colour_code)})</td>
        <td style="${th}">Taşıma</td><td style="${cell}">${esc(TRANSPORT[h.transport_mode] || h.transport_mode)}: ${esc(h.transport_ref)}</td></tr>
    <tr><td style="${th}">Sonuç</td><td style="${cell};font-weight:700;color:${h.result === 'HASARLI' ? '#b3261e' : '#1e7b34'}">${h.result === 'HASARLI' ? 'HASARLI' : 'HASARSIZ'} (${damages.length} hasarlı parça)</td>
        <td style="${th}">Belge (B/L, CMR)</td><td style="${cell}">${esc(h.document_ref)}</td></tr>
  </table>
  <table style="width:100%;border-collapse:collapse;margin-top:8px">
    <tr><td style="${th}width:18%">Teslim eden</td><td style="${cell}width:32%">${esc(h.delivering_party)}<br/>${esc(h.delivering_person)}</td>
        <td style="${th}width:18%">Teslim alan (kontrol eden)</td><td style="${cell}">${esc(h.receiving_party)}<br/>${esc(h.receiving_person)}<br/><span style="color:#555">Kaydı giren kullanıcı sicil ${esc(h.receiving_employee_id)}</span></td></tr>
  </table>
  <div style="font-weight:700;margin:12px 0 4px;color:#15287c">Hasarlar</div>
  <table style="width:100%;border-collapse:collapse">
    <tr><th style="${th}">#</th><th style="${th}">Bölge</th><th style="${th}">Parça</th><th style="${th}">Hasar</th><th style="${th}">Boyut</th>
        <th style="${th}">Açıklama</th><th style="${th}">Kayıt</th><th style="${th}">Sorumlu (RUA)</th></tr>
    ${damages.length === 0 ? `<tr><td style="${cell}" colspan="8">Hasar tespit edilmedi.</td></tr>` : damages.map((l) => `
    <tr><td style="${cell}">${l.line_no}</td><td style="${cell}">${esc(l.zone_name)}</td>
        <td style="${cell}"><b>${esc(l.component_code)}</b> ${esc(l.component_name)}</td>
        <td style="${cell}"><b>${esc(l.damage_code)}</b> ${esc(l.damage_name)}</td>
        <td style="${cell}">${esc(l.size_text)}</td><td style="${cell}">${esc(l.note)}</td>
        <td style="${cell}">${l.is_new ? 'Yeni hasar' : 'Önceden kayıtlı<br/>(ilk: ' + esc(l.first_handover_no) + ')'}<br/><span style="color:#555">${esc(l.status_name || l.status)}</span></td>
        <td style="${cell}">${esc(l.responsible_party)}</td></tr>`).join('')}
  </table>
  <div style="font-weight:700;margin:12px 0 4px;color:#15287c">Gözlemler ve çekinceler</div>
  <table style="width:100%;border-collapse:collapse">
    ${notes.length === 0 ? `<tr><td style="${cell}">Yok.</td></tr>` : notes.map((l) => `
    <tr><td style="${cell}width:14%">${l.line_type === 'CEKINCE' ? 'Çekince' : 'Gözlem'}</td>
        <td style="${cell}">${esc(l.observation_name)}${l.note ? ' — ' + esc(l.note) : ''}</td></tr>`).join('')}
  </table>
  ${photos.length ? `<div style="font-weight:700;margin:12px 0 4px;color:#15287c">Hasar fotoğrafları</div>
  <div style="display:flex;flex-wrap:wrap;gap:8px">${photos.map((p) => `
    <div style="width:236px;border:1px solid #9aa3b5;padding:4px">
      <img src="${files[p.path]}" style="width:100%;height:150px;object-fit:cover;display:block"/>
      <div style="font-size:9px;margin-top:3px">Satır ${p.line.line_no}: ${esc(p.line.component_code)} ${esc(p.line.damage_code)} · ${fmt(p.uploaded_at)}<br/>SHA-256 ${esc(p.sha256.slice(0, 24))}…</div>
    </div>`).join('')}</div>` : ''}
  ${h.delivery ? `<div style="font-weight:700;margin:12px 0 4px;color:#15287c">Teslimat (Proof of Delivery)</div>
  <table style="width:100%;border-collapse:collapse">
    <tr><td style="${th}width:18%">Planlanan varış</td><td style="${cell}width:32%">${esc(h.delivery.planned_location || 'emirde varış yok')}</td>
        <td style="${th}width:18%">Gerçekleşen</td><td style="${cell}">${esc(h.delivery.actual_location)}<br/><span style="color:#555">${esc(h.delivery.actual_place)}</span></td></tr>
    <tr><td style="${th}">Emir / grupaj</td><td style="${cell}">${esc(h.delivery.order_ref)} / ${esc(h.delivery.groupage_no)}</td>
        <td style="${th}">Teslim tarihi</td><td style="${cell}">${h.delivery.earlier_delivery_date ? esc(h.delivery.earlier_delivery_date) + ' (önceden girilmiş)' : fmt(h.delivery.delivered_at)}</td></tr>
  </table>
  ${(h.documents || []).filter((d) => !/\.pdf$/i.test(d.path)).map((d) => `
  <div style="border:1px solid #9aa3b5;padding:4px;margin-top:6px;width:360px">
    <img src="${files[d.path]}" style="width:100%;max-height:260px;object-fit:contain;display:block"/>
    <div style="font-size:9px;margin-top:3px">İmzalı teslim belgesi · ${fmt(d.uploaded_at)} · SHA-256 ${esc(d.sha256.slice(0, 24))}…</div>
  </div>`).join('')}` : ''}
  <table style="width:100%;border-collapse:collapse;margin-top:14px">
    <tr><td style="${th}width:50%">Teslim eden imza: ${esc(h.delivering_person)}</td><td style="${th}">Teslim alan imza: ${esc(h.receiving_person)}</td></tr>
    <tr><td style="${cell}height:90px;text-align:center"><img src="${files[h.delivering_signature]}" style="max-height:84px;max-width:300px"/></td>
        <td style="${cell}text-align:center"><img src="${files[h.receiving_signature]}" style="max-height:84px;max-width:300px"/></td></tr>
  </table>
  <div style="margin-top:6px;font-size:9px;color:#333">Gözlem kaydına imza atılması, teslim edenin sorumluluğu kabul ettiği anlamına gelmez; tarafların gözlemin devir-teslim sırasında yapıldığını teyit ettiğini gösterir (RUA). Önceki devir-teslimde kaydedilmemiş hasar teslim eden tarafa atanır.</div>
  <div style="margin-top:8px;padding:6px;border:1px solid #c9cfdb;background:#f6f8fb;font-family:monospace;font-size:9px;word-break:break-all">
    Kayıt özeti (SHA-256): ${esc(h.record_hash)}<br/>Önceki kayıt: ${esc(h.prev_hash)}<br/>
    İmza dosyaları: ${esc(h.delivering_signature_sha256.slice(0, 16))}… / ${esc(h.receiving_signature_sha256.slice(0, 16))}… · Zaman damgaları sunucu saatidir.
  </div>
  <div style="margin-top:6px;font-size:9px;color:#666;text-align:right">PDF oluşturma: ${fmt(new Date())} · UK Lojistik Control Tower</div>
</div>`;
};

export const downloadTutanakPdf = async (handoverId) => {
    const h = await getHandover(handoverId);
    const paths = [h.delivering_signature, h.receiving_signature,
        ...h.lines.flatMap((l) => l.photos.map((p) => p.path)),
        ...(h.documents || []).filter((d) => !/\.pdf$/i.test(d.path)).map((d) => d.path)];
    const files = {};
    await Promise.all(paths.map(async (p) => { files[p] = await getCustodyFileDataUrl(p); }));

    const holder = document.createElement('div');
    holder.style.cssText = 'position:fixed;left:-10000px;top:0;';
    holder.innerHTML = buildHtml(h, files);
    document.body.appendChild(holder);
    try {
        await Promise.all([...holder.querySelectorAll('img')].map((img) =>
            img.complete ? null : new Promise((r) => { img.onload = r; img.onerror = r; })));
        const canvas = await html2canvas(holder.firstElementChild, { scale: 2, backgroundColor: '#ffffff' });
        const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
        const pageW = 210, pageH = 297;
        const imgH = (canvas.height * pageW) / canvas.width;
        const img = canvas.toDataURL('image/jpeg', 0.92);
        for (let y = 0, page = 0; y < imgH; y += pageH, page++) {
            if (page > 0) pdf.addPage();
            pdf.addImage(img, 'JPEG', 0, -y, pageW, imgH);
        }
        pdf.setProperties({ title: `Tutanak ${h.handover_no}`, subject: `${h.chassis_no} ${h.point_name}`, keywords: h.record_hash });
        pdf.save(`${h.handover_no}_${h.chassis_no}.pdf`);
    } finally {
        document.body.removeChild(holder);
    }
};
